import { gql, QueryHookOptions, TypedDocumentNode } from '@apollo/client';
import { useMemo } from 'react';
import { MessageMedium, MessageType } from 'modules/graphql/types';
import { useGraphql } from 'utils/hooks/useGraphql';

export type QueryMessageTypesRequest = {
  messageMedium?: MessageMedium;
};

type QueryMessageTypesResponse = {
  messageTypes: MessageType[];
};

export const queryMessageTypes = gql`
  query MessageTypesByMedium($messageMedium: MessageMediumDefinition) {
    messageTypes(messageMedium: $messageMedium) {
      id
      name
      subscriptionPolicy
      messageChannel {
        id
        name
        channelType
      }
    }
  }
`;

export type UseQueryMessageTypesState = ReturnType<typeof useQueryMessageTypes>;

export function useQueryMessageTypes(
  options?: QueryHookOptions<QueryMessageTypesResponse, QueryMessageTypesRequest>,
  query: TypedDocumentNode<QueryMessageTypesResponse, QueryMessageTypesRequest> = queryMessageTypes,
) {
  const queryOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
      ...options,
    }),
    [options],
  );

  const {
    data,
    error: hasError = false,
    errorMessage,
    isLoading,
    refetch,
  } = useGraphql<QueryMessageTypesResponse, QueryMessageTypesRequest>(query, queryOptions);

  return { messageTypes: data?.messageTypes || [], errorMessage, hasError, isLoading, refetch };
}
